import { ApiResponse } from "../typings/interfaces";
import fetcher from "../libs/fetcher";

export class ApiHttpService {
  private readonly fetcher: <T = any>(
    url: string,
    init: RequestInit,
  ) => Promise<ApiResponse<T>>;

  constructor() {
    this.fetcher = async (url, init) => fetcher(url, init);
  }

  private getBody(data: unknown): BodyInit | null | undefined {
    if (!data) return;
    if (typeof data === 'string') return data;
    if (data instanceof FormData) return data;
    return JSON.stringify(data);
  }

  public async get<T>(
    path: string,
    params: Params<string> | string = "",
    init: RequestInit = {},
  ): Promise<ApiResponse<T>> {
    const urlParams: string = new URLSearchParams(params).toString();
    return this.fetcher<T>(`${path}?${urlParams}`, { ...init, method: "GET" });
  }

  public async post<T, K = any>(
    path: string,
    data: Nullable<K> = null,
    init: RequestInit = {},
  ): Promise<ApiResponse<T>> {
    return this.fetcher<T>(path, {
      ...init,
      body: this.getBody(data),
      method: "POST",
    });
  }

  public async patch<T, K = any>(
    path: string,
    data: Nullable<K> = null,
    init: RequestInit = {},
  ): Promise<ApiResponse<T>> {
    return this.fetcher<T>(path, { ...init, body: this.getBody(data), method: "PATCH" });
  }

  public async delete<T>(
    path: string,
    init: RequestInit = {},
  ): Promise<ApiResponse<T>> {
    return this.fetcher<T>(path, { ...init, method: "DELETE" });
  }
}
